import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OnJackpotUpdatedSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type OnJackpotUpdatedSubscription = { __typename?: 'Subscription', jackpot_ticker_mutated?: { __typename?: 'jackpot_ticker_mutated', data?: { __typename?: 'jackpot_ticker', data?: string | null } | null } | null };


export const OnJackpotUpdatedDocument = gql`
    subscription OnJackpotUpdated {
  jackpot_ticker_mutated {
    data {
      data
    }
  }
}
    `;

/**
 * __useOnJackpotUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnJackpotUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnJackpotUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnJackpotUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnJackpotUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnJackpotUpdatedSubscription, OnJackpotUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnJackpotUpdatedSubscription, OnJackpotUpdatedSubscriptionVariables>(OnJackpotUpdatedDocument, options);
      }
export type OnJackpotUpdatedSubscriptionHookResult = ReturnType<typeof useOnJackpotUpdatedSubscription>;
export type OnJackpotUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnJackpotUpdatedSubscription>;